import { useSelector } from 'react-redux';
import { useEffect, useContext, useState } from 'react';
import { UserContext } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { isRoot, getUserInfo } from 'utils/common';
import { API } from 'utils/api';
import EmailModal from 'component/EmailModal';
import PhoneModal from 'component/PhoneModal';

const AuthGuard = ({ children }) => {
  const account = useSelector((state) => state.account);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openEnterpriseAuthenticatio, setOpenEnterpriseAuthentication] = useState(false);
  const [openPersonalAuthentication, setOpenPersonalAuthentication] = useState(false);
  const [inputs, setInputs] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);
  const [openPhone, setOpenPhone] = useState(false);
  const { isUserLoaded } = useContext(UserContext);
  const navigate = useNavigate();
  const userinfo = getUserInfo();
  const showModal = () => setIsModalOpen(true);
  const hideModel = () => setIsModalOpen(false);

  const goPersonalAuthPage = () => {
    hideModel();
    navigate('/personal/auth');
  };

  const goEnterpriseAuthPage = () => {
    hideModel();
    navigate('/enterprise/auth');
  };

  const getOptions = async () => {
    try {
      const res = await API.get('/api/option/');
      const { success, data } = res.data;
      if (success) {
        const options = {};
        data.forEach((item) => {
          if (item.key === 'PersonalAuthentication' || item.key === 'EnterpriseAuthentication') {
            options[item.key] = item.value === 'true';
          }
        });
        return options;
      }
      return {};
    } catch (error) {
      console.error('Error fetching options:', error);
      return {};
    }
  };

  const emailAndPhoneAuth = () => {
    if (userinfo?.role === 100 || userinfo?.role === 10) return;

    setInputs(userinfo);

    if (!userinfo?.email) setOpenEmail(true);
    if (!userinfo?.phone) setOpenPhone(true);
  };

  useEffect(() => {
    emailAndPhoneAuth();
  }, []);

  useEffect(() => {
    if (isUserLoaded && !userinfo) {
      navigate('/');
      return;
    }

    (async () => {
      const authentication = await getOptions();
      if (!isRoot() && userinfo) {
        if (authentication.PersonalAuthentication && authentication.EnterpriseAuthentication) {
          if (userinfo?.personal_auth_status === 0 && userinfo?.enterprise_auth_status === 0) {
            setOpenEnterpriseAuthentication(true);
            setOpenPersonalAuthentication(true);
            showModal();
          }
        } else if (authentication.EnterpriseAuthentication && userinfo?.enterprise_auth_status === 0) {
          setOpenEnterpriseAuthentication(true);
          showModal();
        } else if (authentication.PersonalAuthentication && userinfo?.personal_auth_status === 0) {
          setOpenPersonalAuthentication(true);
          showModal();
        }
      }
    })();
  }, [account, navigate, isUserLoaded]);

  return (
    <>
      <EmailModal
        title="请先绑定邮箱"
        bind
        open={openEmail}
        userinfo={inputs}
        handleClose={() => setOpenEmail(false)}
        updateUserInfo={(email) => setInputs((prev) => ({ ...prev, email }))}
      />
      <PhoneModal
        bind
        title="请先绑定手机号"
        open={openPhone}
        userinfo={inputs}
        handleClose={() => setOpenPhone(false)}
        updateUserInfo={(phone) => setInputs((prev) => ({ ...prev, phone }))}
      />
      {children}
    </>
  );
};

export default AuthGuard;
